import CircularProgress from '@mui/material/CircularProgress';
import CustomDialog from 'widgets/component/CustomDialog';
import DataTableDetailOrder from 'widgets/customDialogComponentDetails/ComponentDialog';

const TokuDetailsDialog = ({
  open,
  onClose,
  detailsTransactionsToku,
  handleOpenPopUp,
  setOpenActionFraud,
  loadingDetail,
  CircularProgressStyle,
}) => {
  const response = detailsTransactionsToku?.response;

  return (
    <CustomDialog
      fullWidth
      title={
        detailsTransactionsToku?.response?.payment_info === null
          ? 'No hay datos'
          : 'Transacción Toku'
      }
      content={
        loadingDetail ? (
          <CircularProgress sx={CircularProgressStyle?.CircularProgress} />
        ) : response ? (
          <DataTableDetailOrder
            type='detailsToku'
            handleOpenPopUp={handleOpenPopUp}
            setOpenActionFraud={setOpenActionFraud}
            response={response}
            idTransaction={response?.transaction_type?.transaction_id ?? ''}
            onClose={onClose}
          />
        ) : (
          <p style={{ padding: '10px', textAlign: 'center' }}>No hay información para mostrar.</p>
        )
      }
      open={open}
      onClose={onClose}
      maxWidth='md'
      extraButtons={[
        {
          label: 'Aceptar',
          variant: 'contained',
          onClick: onClose,
          buttonColor: 'purple',
          textColor: 'white',
        },
      ]}
    />
  );
};

export default TokuDetailsDialog;
